import { PaginateResult } from 'resources/types/shared';
import { ImpostoDto, ImpostoQueryParams } from './../typings/index';
import { useQuery } from 'react-query';
import http from 'infra/http';
import { AxiosError } from 'axios';

export function useListarImpostos(query: ImpostoQueryParams) {
    return useQuery<PaginateResult<ImpostoDto>, AxiosError>(
        [`/v1/imposto`, query],
        async () => {
            const { data } = await http.get<PaginateResult<ImpostoDto>>("/v1/imposto", {
                params: query,
            });

            return data;
        }
    );
}

